import languageNewVer from "./languageNewVer.json";

export const en = {
  languageNewVer,
};
